import { Injectable } from '@angular/core';

export type AppTheme = 'light' | 'dark' | 'counsel' | 'harbor' | 'contrast';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly themes: { id: AppTheme; label: string }[] = [
    { id: 'light', label: 'Default' },
    { id: 'dark', label: 'Dark' },
    { id: 'counsel', label: 'Counsel' },
    { id: 'harbor', label: 'Harbor' },
    { id: 'contrast', label: 'High Contrast' },
  ];

  private readonly storageKey = 'al-theme';
  private current: AppTheme = 'light';
  private transitionTimer?: ReturnType<typeof setTimeout>;

  init(): void {
    const saved = localStorage.getItem(this.storageKey) as AppTheme;
    if (saved && saved !== 'light' && this.themes.some(t => t.id === saved)) {
      this.setTheme(saved, false);
    } else {
      this.current = 'light';
      document.body.removeAttribute('data-theme');
    }
  }

  getTheme(): AppTheme {
    return this.current;
  }

  setTheme(theme: AppTheme, animate = true): void {
    if (animate && theme !== this.current) {
      document.body.classList.add('theme-transitioning');
      void document.body.offsetWidth;
      clearTimeout(this.transitionTimer);
      this.transitionTimer = setTimeout(() => {
        document.body.classList.remove('theme-transitioning');
      }, 260);
    }

    this.current = theme;
    if (theme === 'light') {
      document.body.removeAttribute('data-theme');
      localStorage.removeItem(this.storageKey);
    } else {
      document.body.setAttribute('data-theme', theme);
      localStorage.setItem(this.storageKey, theme);
    }
  }
}
